import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Compliance');

// FETCH DNC STATUS
export const GetDncStatus = actionCreator.async<DncQueryParams, DncStatusResponse>(
    'GET_DNC_STATUS'
);

// CREATE CONTACT ATTEMPT
export const CreateContactAttempt = actionCreator.async<CreateContactAttemptParams, void>(
    'CREATE_CONTACT_ATTEMPT'
);

export const ClearDncStatus = actionCreator('CLEAR_DNC_STATUS');

export interface DncQueryParams {
    phone: string;
    hasCallback: boolean;
    zipCode?: string;
    businessOwner?: string;
    agentCode?: string;
    createdOn?: string;
}

export interface CreateContactAttemptParams {
    phone: string;
    hasCallback: boolean;
    zipCode?: string;
}

export interface ContactAttemptResponse {
  PhoneNumber: string;
  CanContact: boolean;
  Reason: string;
  State?: string;
  ExpiryDateUtc?: string;
  CacheExpiryUtc?: string;
  Contacts?: unknown[];
  IsDnc?: boolean;
}

export interface DncStatusApiResponse{
    PhoneNumber: string;
    IsDoNotCall: boolean,
    ContactStatus: ContactStatus;
}

interface ContactStatus {
    PhoneNumber: string;
    State?: string;
    ExpiryDateUtc?: string;
    CanContact: boolean;
    Reason: string;
    CacheExpiryUtc?: string;
    Contacts?: unknown[];
}

export interface DncStatusResponse {
    phone: string;
    isDnc?: boolean;
    canContact: boolean;
    reason: string;
}

export enum ComplianceEndpoint {
    GetContactAttempts,
    DncStatus,
    CreateContactAttempt
}